const [ w, d ] = [ window, document ]

const init = () => {

  $(() => {
    const $requireNote = $('<p class="require-note">※必須事項は必ずご入力下さい。</p>');
    $requireNote.insertAfter('ol.formflow');
  });

}

export default function CONTACT () {
 $( init )
}